import {Directive, Input} from "@angular/core";
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from "@angular/forms";

import * as Models from "app/services/proxy/model/models";

@Directive({
    selector: "[csTagRuleConditions]",
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: TagRuleConditionsValidatorDirective,
            multi: true
        }
    ],
    standalone: false
})
export class TagRuleConditionsValidatorDirective implements Validator
{
    public static ERROR_KEY: string = "csTagRuleConditions";

    private m_conditions: Models.TagBaselineRuleCondition[];
    @Input("csTagRuleConditions") set conditions(conditions: Models.TagBaselineRuleCondition[])
    {
        this.m_conditions = conditions?.map((condition) => Models.TagBaselineRuleCondition.newInstance(condition)) || [];
    }

    validate(control: AbstractControl): ValidationErrors
    {
        if (this.m_conditions.length && control.value && !TagRuleConditionsValidatorDirective.validateTagValue(this.m_conditions, control.value))
        {
            return {[TagRuleConditionsValidatorDirective.ERROR_KEY]: true};
        }

        return null;
    }

    static isInvalid(errors: ValidationErrors): boolean
    {
        return errors && errors[TagRuleConditionsValidatorDirective.ERROR_KEY];
    }

    public static validateTagValue(conditions: Models.TagBaselineRuleCondition[],
                                   value: string): boolean
    {
        return conditions.every((condition) =>
                                {
                                    if (condition.starts_with && !value.startsWith(condition.starts_with)) return false;
                                    if (condition.contains && value.indexOf(condition.contains) < 0) return false;
                                    if (condition.ends_with && !value.endsWith(condition.ends_with)) return false;

                                    return true;
                                });
    }
}

@Directive({
    selector: "[csTagRuleRegex]",
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: TagRuleRegexValidatorDirective,
            multi: true
        }
    ],
    standalone: false
})
export class TagRuleRegexValidatorDirective implements Validator
{
    public static ERROR_KEY: string = "csTagRuleRegex";

    private m_conditions: Models.TagBaselineRuleRegex[] = [];
    @Input("csTagRuleRegex") set conditions(conditions: Models.TagBaselineRuleRegex[])
    {
        this.m_conditions = conditions || [];
    }

    validate(control: AbstractControl): ValidationErrors
    {
        if (this.m_conditions.length && control.value && !TagRuleRegexValidatorDirective.validateTagValue(this.m_conditions, control.value))
        {
            return {[TagRuleRegexValidatorDirective.ERROR_KEY]: true};
        }

        return null;
    }

    static isInvalid(errors: ValidationErrors): boolean
    {
        return errors && errors[TagRuleRegexValidatorDirective.ERROR_KEY];
    }

    public static validateTagValue(regexes: Models.TagBaselineRuleRegex[],
                                   value: string): boolean
    {
        return value && regexes?.every((regexRule) =>
                                       {
                                           let regex = regexRule.regex_pattern.trim();
                                           if (regex[0] === "/" && regex[regex.length - 1] === "/") regex = regex.substring(1, regex.length - 1);
                                           return new RegExp(regex).test(value);
                                       });
    }
}
